// Do not import @rbx/intl here, it will cause issues with ssr since the package uses lifecycle methods
import TranslationNamespace from '../enums/TranslationNamespace';
import Locale from '../enums/Locale';
import NativeName from '../enums/NativeName';

export const defaultLocale = Locale.English;

export const defaultLocaleInfo = {
  locale: defaultLocale,
  nativeName: NativeName.English,
};

// Order of available locales determines the order in the language menu
// It should be the same as on https://www.roblox.com/my/account#!/info
export const availableDocsContentLocales: Locale[] = [
  Locale.Indonesian,
  Locale.German,
  Locale.English,
  Locale.Spanish,
  Locale.French,
  Locale.Italian,
  Locale.Polish,
  Locale.BrazilPortuguese,
  Locale.Vietnamese,
  Locale.Turkish,
  Locale.Thai,
  Locale.SimplifiedChinese,
  Locale.TraditionalChinese,
  Locale.Japanese,
  Locale.Korean,
];

export const LocaleLanguageMap = new Map([
  [Locale.Indonesian, NativeName.Indonesian],
  [Locale.German, NativeName.German],
  [Locale.English, NativeName.English],
  [Locale.Spanish, NativeName.Spanish],
  [Locale.French, NativeName.French],
  [Locale.Italian, NativeName.Italian],
  [Locale.Polish, NativeName.Polish],
  [Locale.BrazilPortuguese, NativeName.BrazilPortuguese],
  [Locale.Vietnamese, NativeName.Vietnamese],
  [Locale.Turkish, NativeName.Turkish],
  [Locale.Thai, NativeName.Thai],
  [Locale.SimplifiedChinese, NativeName.SimplifiedChinese],
  [Locale.TraditionalChinese, NativeName.TraditionalChinese],
  [Locale.Japanese, NativeName.Japanese],
  [Locale.Korean, NativeName.Korean],
]);

export const availableCreatorHubLocales = Object.values(Locale) as Locale[];

export const defaultPageLayoutTranslationNamespaces = [
  TranslationNamespace.Navigation,
  TranslationNamespace.Common,
  TranslationNamespace.Alerts,
  TranslationNamespace.UseStudio,
  TranslationNamespace.APIReference, // used to label search results
  TranslationNamespace.Search,
  TranslationNamespace.DashboardError,
];

export const pageTranslationNamespaces = [
  TranslationNamespace.OpenCloud,
  TranslationNamespace.ScopeSystem,
  TranslationNamespace.CreatorDashboardHome,
  TranslationNamespace.APIReference,
  TranslationNamespace.TagDescription,
  TranslationNamespace.TagLabel,
  TranslationNamespace.Article,
];

export const LocaleByPathPrefix: Map<string, Locale> = new Map([
  ['id-id', Locale.Indonesian],
  ['de-de', Locale.German],
  ['en-us', Locale.English],
  ['es-es', Locale.Spanish],
  ['fr-fr', Locale.French],
  ['it-it', Locale.Italian],
  ['pl-pl', Locale.Polish],
  ['pt-br', Locale.BrazilPortuguese],
  ['vi-vn', Locale.Vietnamese],
  ['tr-tr', Locale.Turkish],
  ['th-th', Locale.Thai],
  ['zh-cn', Locale.SimplifiedChinese],
  ['zh-tw', Locale.TraditionalChinese],
  ['ja-jp', Locale.Japanese],
  ['ko-kr', Locale.Korean],
]);

export const LocaleHrefLangMap: Map<Locale, string> = new Map([
  [Locale.Indonesian, 'id'],
  [Locale.German, 'de'],
  [Locale.English, 'en'],
  [Locale.Spanish, 'es'],
  [Locale.French, 'fr'],
  [Locale.Italian, 'it'],
  [Locale.Polish, 'pl'],
  [Locale.BrazilPortuguese, 'pt-BR'],
  [Locale.Vietnamese, 'vi'],
  [Locale.Turkish, 'tr'],
  [Locale.Thai, 'th'],
  // https://developers.google.com/search/docs/specialty/international/localized-versions#language-codes
  [Locale.SimplifiedChinese, 'zh-Hans'],
  [Locale.TraditionalChinese, 'zh-Hant'],
  [Locale.Japanese, 'ja'],
  [Locale.Korean, 'ko'],
]);
